import styled from 'styled-components';
import Notification from '@components/Notification';

export const ServerNotification = styled(Notification)`
  color: ${({ theme }) => theme.color.white};
  margin-bottom: ${({ theme }) => theme.x3space}rem;
`;

export const ButtonList = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
`;

export const SocialSignInLabel = styled('p')`
  ${({ theme }) => theme.typography.tiny}
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const FormContainer = styled('div')`
  min-height: 238px;
`;
